let utils = {}

utils.getPrizeFormatted = prizeAmount => {
	if (!prizeAmount || prizeAmount == undefined || prizeAmount == "" || prizeAmount == null)
		prizeAmount = 0
	return `$${prizeAmount}`
}

export default utils
